import axios from 'axios';
import { utilityService } from '@/services/utilityService.js';

export const surveyService = {
    getSurvey: (surveyId) => __getSurvey(surveyId),
		getSectionMetadata: (surveyId, sectionId, fnCallback) => __getSectionMetadata(surveyId, sectionId, fnCallback),
    getQuestionStatuses: (surveyId) => __getQuestionStatuses(surveyId),
    updateSurveyStatus: (surveyId, surveyStatus) => __updateSurveyStatus(surveyId, surveyStatus),
    updateMandatoryQuestionsAnswered: (surveyId, mandatoryQuestionsAnswered) => __updateMandatoryQuestionsAnswered(surveyId, mandatoryQuestionsAnswered),
    getSurveyType: (surveyId) => __getSurveyType(surveyId),
    lockSurvey: (surveyId, bLock) => __lockSurvey(surveyId, bLock),
    getLockStatus: (surveyId) => __getLockStatus(surveyId),
    setCurrentUser: (surveyId, isCurrent) => __setCurrentUser(surveyId, isCurrent),
    setAggregate:(surveyId, aggregateType) => __setAggregate(surveyId, aggregateType),
    getAggregationHistory: (surveyId) => __getAggregationHistory(surveyId),
    setSurveyLockStatus: (surveyId, lock) => __setSurveyLockStatus(surveyId, lock),
    savesubOffice:(surveyId,selectDeptment,officeName, officeAbbreviation, description, firstName, lastName, emailId, title, supervisorfirstName, supervisorlastName, supervisoremailId, supervisorTitle, userId, currentVolume, addnewFlag)=>__savesubOffice(surveyId,selectDeptment,officeName, officeAbbreviation, description, firstName, lastName, emailId, title, supervisorfirstName, supervisorlastName, supervisoremailId, supervisorTitle, userId, currentVolume, addnewFlag),
    saveNewAgencyWithNewOffice:(selectSurveyType,agency,surveyId,selectDeptment,officeName, officeAbbreviation, description, firstName, lastName, emailId, title, supervisorfirstName, supervisorlastName, supervisoremailId, supervisorTitle, addnewFlag)=>__saveNewAgencyWithNewOffice(selectSurveyType,agency,surveyId,selectDeptment,officeName, officeAbbreviation, description, firstName, lastName, emailId, title, supervisorfirstName, supervisorlastName, supervisoremailId, supervisorTitle, addnewFlag),
    getOfficeInfo:(officename) => __getOfficeInfo(officename),
    makeUseOfAvaiableOffice:(participatingOfficesList) => __makeUseOfAvaiableOffice(participatingOfficesList),
    getExcelDownload:(surveyId, isEmpty) => __getExcelDownload(surveyId, isEmpty),
    getCountryInfo:(countryname,surveyId, vqId) => _getCountryInfo(countryname,surveyId, vqId),
    saveAnswerCountries:(surveyId, countryId, con, pla, tot, vqId) => __saveAnswerCountries(surveyId, countryId, con, pla, tot, vqId),
    saveCountries:(surveyId, selectedCountries, userName , vqId) => __saveCountries(surveyId, selectedCountries, userName , vqId),
    saveOrganization:(isActive, organizationFice, organizationPFice, organizationName, organizationShortName, organizationType, address, city, state, zip,
        phone, hbcu, hdg, nptype, toc, instLvl, campusseq, camcode, hhe, tribel, minority, system, sysflag, webAddress, comments, dstSorterName, dstName,
        unitId, version, styleGuideReviewCompleted, styleGuideReviewCompletedDate, haie, cleanupcode, lastFyFunded, closed, ein, flag) => __saveOrganization(isActive, organizationFice, organizationPFice, organizationName, organizationShortName, organizationType, address, city, state, zip,
            phone, hbcu, hdg, nptype, toc, instLvl, campusseq, camcode, hhe, tribel, minority, system, sysflag, webAddress, comments, dstSorterName, dstName,
            unitId, version, styleGuideReviewCompleted, styleGuideReviewCompletedDate, haie, cleanupcode, lastFyFunded, closed, ein, flag),
    getSurveyId: (volume, username) => __getSurveyId(volume, username),
    deleteOffice: (surveyId, officeId) => __deleteOffice(surveyId, officeId),
		getOrganization: (orgname) => __getOrganization(orgname)
};

/**
 * Returns the survey data based on identifier passed in.
 * @param {string} survey identifier
 * @returns the promise
 */
function __getSurvey (surveyId) {
    return axios.get(utilityService.getApiUrl('survey/' + surveyId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getSurveyId (volume, username) {
    return axios.get(utilityService.getApiUrl(`survey/${volume}/getsurveyId/${username}`),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __getSectionMetadata (surveyId, sectionId) {
    // api/survey/1/section/1
    return axios.get(utilityService.getApiUrl('survey/' + surveyId + '/section/' + sectionId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

/**
 * Gets a collection of question sections and their statuses.
 * @param {int} surveyId - The survey identifier
 */
function __getQuestionStatuses (surveyId) {
	return axios.get(utilityService.getApiUrl(`survey/${surveyId}/surveyStatus`),
	{
		headers: utilityService.getHeaders()
	});
}

/**
 * Update the status of a survey.
 * @param {int} surveyId - The survey identifier
 */
function __updateSurveyStatus (surveyId, surveyStatus) {
	return axios.put(utilityService.getApiUrl(`survey/${surveyId}/status`),
	surveyStatus,
	{
		headers: utilityService.getHeaders()
	});
}

/**
 * Updates the mandatoryQuestionsAnswered flag of the survey.
 */
function __updateMandatoryQuestionsAnswered (surveyId, flag) {
	return axios.put(utilityService.getApiUrl(`survey/${surveyId}/mandatoryQuestionsAnswered`),
	flag,
	{
		headers: utilityService.getHeaders()
	});
}

/**
 * Returns the survey type based on identifier passed in.
 * @param {int} surveyId - The survey identifier
 * @returns the promise
 */
function __getSurveyType (surveyId) {
    return axios.get(utilityService.getApiUrl('survey/type/' + surveyId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

/**
 * Locks\unlocks the specified survey
 * @param {*} surveyId - survey identifier
 * @param {*} bLock - boolean which indicates whether we are locking survey (true) or not (false)
 */
function __lockSurvey (surveyId, bLock) {
    return axios.post(utilityService.getApiUrl(`survey/${surveyId}/lockorunlocksurvey/${bLock}`),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __setSurveyLockStatus(surveyId, lock) {
    return axios.post(utilityService.getApiUrl(`survey/surveyrootstatus`),
        { SurveyId: surveyId, LockUnLock: lock },
        {
            headers: utilityService.getHeaders()
        }
    );
}

function __deleteOffice(surveyId, officeId) {
    return axios.delete(utilityService.getApiUrl('survey/' + surveyId + '/officeId/' + officeId),
        // Third parameter is the configuration object
        {
            headers: utilityService.getHeaders()
        }
    );
}

/**
 * Returns whether or not the specified survey is locked
 * @param {*} surveyId - survey identifier
 */
function __getLockStatus (surveyId) {
  return axios.get(utilityService.getApiUrl(`survey/lock-status/${surveyId}`),
    {
			headers: utilityService.getHeaders()
    }
	);
}

/**
 * Sets whether a user is currently in the survey
 * @param {*} surveyId - survey identifier
 * @param {*} isCurrent - set current user or set null based on T or F
 */
function __setCurrentUser (surveyId, isCurrent) {
  return axios.put(utilityService.getApiUrl(`survey/${surveyId}/current/${isCurrent}`),
			// Third parameter is the configuration object
			null,
      {
					headers: utilityService.getHeaders()
      }
  );
}
/**
 * Sets whether a user is currently in the survey
 * @param {*} surveyId - survey identifier
 * @param {*} aggregateType - Overwrite or Sumall will be set
 */
 function __setAggregate(surveyId, aggregateType) {

    return axios.post(utilityService.getApiUrl('survey/aggregate'),
            // Second parameter is the data/body
            { SurveyId: surveyId, SumAll: aggregateType },
            // Third parameter is the configuration object
            {
                headers: utilityService.getHeaders()
            }
        )
        .then(function (response) {
			console.log(response);

        })
        .catch(function (e) {
            if (!e.response) {
				// network error
				this.errorStatus = 'Error: Network Error';
			} else {
				this.errorStatus = e.response.data.message;
			}
			console.log("Error " + e.response.data.message);
            throw e;
        }
    );

  }

  /**
 * Returns whether or not the specified survey is locked
 * @param {*} surveyId - survey identifier
 */
function __getAggregationHistory(surveyId) {
    return axios.get(utilityService.getApiUrl(`survey/aggregatehistory/${surveyId}`),
      {
              headers: utilityService.getHeaders()
      }
      );
  }


  function __savesubOffice(surveyId, selectDeptment, officeName, officeAbbreviation, description, firstName, lastName, emailId, title, supervisorfirstName, supervisorlastName, supervisoremailId, supervisorTitle, userId, currentVolume, addnewFlag) {
	return axios.post(utilityService.getApiUrl('survey/savesubOffice/'),
        {SurveyId:surveyId, DepartmentId:selectDeptment, OfficeName:officeName, OfficeAbbreviation:officeAbbreviation, Description:description, FirstName:firstName, LastName:lastName, EmailId:emailId, Title:title, SupervisorfirstName:supervisorfirstName, SupervisorlastName:supervisorlastName, SupervisoremailId:supervisoremailId, SupervisorTitle:supervisorTitle, UserId: userId, Volume: currentVolume, AddnewFlag: addnewFlag},
		{
			headers: utilityService.getHeaders()
		});
}

function __saveNewAgencyWithNewOffice(selectSurveyType,agency,surveyId, selectDeptment, officeName, officeAbbreviation, description, firstName, lastName, emailId, title, supervisorfirstName, supervisorlastName, supervisoremailId, supervisorTitle, addnewFlag) {
	return axios.post(utilityService.getApiUrl('survey/saveNewAgencyWithNewOffice/'),
        {SurveyType:selectSurveyType, Agency:agency,SurveyId:surveyId, DepartmentId:selectDeptment, OfficeName:officeName, OfficeAbbreviation:officeAbbreviation, Description:description, FirstName:firstName, LastName:lastName, EmailId:emailId, Title:title, SupervisorfirstName:supervisorfirstName, SupervisorlastName:supervisorlastName, SupervisoremailId:supervisoremailId, SupervisorTitle:supervisorTitle, AddnewFlag: addnewFlag},
		{
			headers: utilityService.getHeaders()
		});
}

function __saveAnswerCountries(surveyId, countryId, con, pla, tot, vqId) {
	return axios.post(utilityService.getApiUrl('survey/saveAnswerCountries/'),
        {SurveyId:surveyId, CountryId:countryId, Con:con, Pla:pla, Tot:tot, QId: vqId},
		{
			headers: utilityService.getHeaders()
		});
}

function __getOfficeInfo(officename) {
    return axios.get(utilityService.getApiUrl(`survey/getOffice/${officename}`),
      {
              headers: utilityService.getHeaders()
      });
  }

  function __makeUseOfAvaiableOffice(participatingOfficesList)
  {
    return axios.post(utilityService.getApiUrl(`survey/makeUseofOffices/`),
    {ParticipatingOfficesList:participatingOfficesList},
    {
            headers: utilityService.getHeaders()
    });
  }

  function __getExcelDownload(surveyId, isEmpty) {
    return axios.get(utilityService.getApiUrl(`survey/${surveyId}/excel/${isEmpty}`),
      {
              responseType:'blob',
              headers: utilityService.getHeaders()
      }
      );
  }

  function _getCountryInfo(countryname,surveyId, vqId) {
    return axios.get(utilityService.getApiUrl(`survey/getCountryInfo/${countryname}/surveyId/${surveyId}/qId/${vqId}`),
      {
              headers: utilityService.getHeaders()
      });
  }

  function __saveCountries(surveyId, selectedCountries, userName , vqId) {
	return axios.post(utilityService.getApiUrl('survey/saveCountries/'),
        {SurveyId:surveyId, SelectedCountries:selectedCountries, UserName:userName, QId: vqId},
		{
			headers: utilityService.getHeaders()
		});
}

function __saveOrganization (isActive, organizationFice, organizationPFice, organizationName, organizationShortName, organizationType, address, city, state, zip,
	phone, hbcu, hdg, nptype, toc, instLvl, campusseq, carncode, hhe, tribal, minority, system, sysflag, webAddress, comments, dstSorterName, dstName,
	unitId, version, styleGuideReviewCompleted, styleGuideReviewCompletedDate, haie, cleanupcode, lastFyFunded, closed, ein, flag) {
        return axios.post(utilityService.getApiUrl('survey/saveOrganization/'),
        { IsActive: isActive, OrganizationFice: organizationFice, OrganizationPFice: organizationPFice, OrganizationName: organizationName,
					OrganizationShortName: organizationShortName, OrganizationTypeCode: organizationType, Address: address, City: city, State: state,
					Zip: zip, Phone: phone, Hbcu: hbcu, Hdg: hdg, Nptype: nptype, Toc: toc, InstLvl: instLvl, Campusseq: campusseq, CarnCode: carncode,
					Hhe: hhe, Tribal: tribal, Minority: minority, SysFlag: sysflag, System: system, WebAddress: webAddress, Comments: comments,
					DstSorterName: dstSorterName, DstName: dstName, UnitId: unitId, Version: version, StyleGuideReviewCompleted: styleGuideReviewCompleted,
					StyleGuideReviewCompletedDate: styleGuideReviewCompletedDate, Haie: haie, Cleanupcode: cleanupcode, LastFyFunded: lastFyFunded,
					Closed: closed, EIN: ein, Flag: flag },
		{
			headers: utilityService.getHeaders()
		});
	}

	function __getOrganization(orgname) {
    return axios.get(utilityService.getApiUrl(`survey/getOrganization/${orgname}`),
      {
              headers: utilityService.getHeaders()
      });
  }
